import "./Project.css"
import onlinetest from "./onlinetest.png"
import addtocart from "./addtocart.png"
import bmi from "./bmi.png"
import student from "./student.png"
import ecommerce from "./ecomm.avif"
import { useState } from "react"

const Project = ()=>
{
    const [data] = useState([
        {
            img : student,
            name : "Student Management System",
            p1  : "Developed a Student Management System using MERN stack",
            p2 : "Implemented add, view, update, and delete student details"
        },
        {
            img : bmi,
            name : "BMI Calculator",
            p1  : "Built a BMI Calculator application using MERN stack",
            p2 : "Collected user inputs and calculated BMI dynamically"
        },
        {
            img : ecommerce,
            name: "Mini E-Commerce Web Application",
            p1: "Built a MERN stack e-commerce app with product listing, search, and cart.",
            p2: "Handled order placement, stock updates, and smooth cart operations."
        },
        {
            img : onlinetest,
            name : "Online Test System",
            p1  : "Developed an Online Test System using MERN stack",
            p2 : "Implemented multiple-choice questions with automatic evaluation"
        },
        {
            img : addtocart,
            name : "Add to Cart Module",
            p1  : "Implemented Add to Cart functionality in a MERN-based application",
            p2 : "Enabled users to add, remove, and update product quantities"
        },

    ])
        
    
    return(
        <div className="project">
            <h1>My <span>Projects</span></h1>

            <div className="proj">
                {data.map((xx)=>
                (
                    <div className="one" key={xx.name}>
                        <img src={xx.img} alt="" />
                        <h1 className="title">{xx.name}</h1>
                        <p> 🔹 {xx.p1}</p>
                        <p> 🔹 {xx.p2}</p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Project